import configuration from '@/taskpane/common/configuration'
import { officeApiItem_CustomPropertiesLoadAsync, officeApiItem_CustomPropertiesSaveAsync } from './async/office-api-mailbox-item-async'

export async function officeGetCustomProperty(prop: string): Promise<string | null> {
  const customProperties: Office.CustomProperties = await officeApiItem_CustomPropertiesLoadAsync()
  if (customProperties) {
    return customProperties.get(prop) || ''
  } else {
    return null
  }
}

export async function officeGetTrackingId(): Promise<string | null> {
  return officeGetCustomProperty(configuration.TRACKING_ID_PROPERTY_NAME)
}

export async function officeGetReplyTrackingId(): Promise<string | null> {
  return officeGetCustomProperty(configuration.REPLY_TRACKING_ID_PROPERTY_NAME)
}

export async function officeSetCustomProperty(prop: string, data: string): Promise<boolean> {
  const customProperties: Office.CustomProperties = await officeApiItem_CustomPropertiesLoadAsync()
  customProperties.set(prop, data)

  try {
    return await officeApiItem_CustomPropertiesSaveAsync(customProperties)
  } catch {
    return false
  }
}

export async function officeSaveTrackingId(data: string): Promise<boolean> {
  const customProperties: Office.CustomProperties = await officeApiItem_CustomPropertiesLoadAsync()
  customProperties.set(configuration.TRACKING_ID_PROPERTY_NAME, data)
  customProperties.set(configuration.CI_HANDLED_PROPERTY_NAME, 'false')

  try {
    return await officeApiItem_CustomPropertiesSaveAsync(customProperties)
  } catch {
    return false
  }
}

export async function officeSaveReplyTrackingId(data: string): Promise<boolean> {
  return officeSetCustomProperty(configuration.REPLY_TRACKING_ID_PROPERTY_NAME, data)
}

const exportFunctions = {
  get: officeGetCustomProperty,
  set: officeSetCustomProperty,
  getTrackingId: officeGetTrackingId,
  setTrackingId: officeSaveTrackingId,
  getReplyTrackingId: officeGetReplyTrackingId,
  setReplyTrackingId: officeSaveReplyTrackingId,
}

export default exportFunctions
